export default "__VITE_ASSET__H8umPDL2__"